<template>
  <div class="dashboard-kpi p-2">
    <global-loading v-if="$store.state.kpiStore.ssi_count_loading" />
    <div class="header-wrapper">
      <div @click="goBack">
        <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.1666 9H3.83331M3.83331 9L8.83331 14M3.83331 9L8.83331 4" stroke="#ED1D24" stroke-width="1.66667"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="pointer" @click="downloadReport()">
        <div class="text-bold text-center">Supplier Satisfaction Index - Waiting to Confirm</div>
      </div>
      <div>
        <!-- <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i> -->
      </div>
    </div>
    <div class="top-action-wrapper">
      <button @click="mailAllPIC">Email Seluruh PIC</button>
      <div class="input-wrapper">
        <input type="text" v-model="searchPcrGrupPIC" @input="applyFilter" placeholder="Cari PCR Grup / PIC">
        <span class="search-icon">
          <i class="fa-solid fa-magnifying-glass"></i>
        </span>
      </div>
      <div class="input-wrapper">
        <input type="text" v-model="searchNamaVendor" @input="applyFilter" placeholder="Cari Nama Vendor">
        <span class="search-icon">
          <i class="fa-solid fa-magnifying-glass"></i>
        </span>
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>No</th>
            <th>PCR Grup</th>
            <th>PIC 1</th>
            <th>Email PIC 1</th>
            <th>PIC 2</th>
            <th>Email PIC 2</th>
            <th>Status Konfirmasi</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in filteredData">
            <tr :key="'row-' + index" @click="preventDetailToggle(index, $event)">
              <td>
                <svg :class="checkMailSend(item) ? '' : 'gray-stroke'" @click="mailPcrGrup(index, item)" width="15"
                  height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.5 3.5L5.58246 6.35772C5.91304 6.58913 6.07834 6.70484 6.25813 6.74965C6.41695 6.78924 6.58305 6.78924 6.74187 6.74965C6.92166 6.70484 7.08695 6.58913 7.41754 6.35772L11.5 3.5M3.9 10H9.1C9.94008 10 10.3601 10 10.681 9.83651C10.9632 9.6927 11.1927 9.46323 11.3365 9.18099C11.5 8.86012 11.5 8.44008 11.5 7.6V4.4C11.5 3.55992 11.5 3.13988 11.3365 2.81901C11.1927 2.53677 10.9632 2.3073 10.681 2.16349C10.3601 2 9.94008 2 9.1 2H3.9C3.05992 2 2.63988 2 2.31901 2.16349C2.03677 2.3073 1.8073 2.53677 1.66349 2.81901C1.5 3.13988 1.5 3.55992 1.5 4.4V7.6C1.5 8.44008 1.5 8.86012 1.66349 9.18099C1.8073 9.46323 2.03677 9.6927 2.31901 9.83651C2.63988 10 3.05992 10 3.9 10Z"
                    :stroke="selectedMailRowIndex === index ? 'currentColor' : 'black'" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </td>
              <td>{{ index + 1 }}</td>
              <td>{{ item.PCR_GROUP }}</td>
              <td>{{ item.PIC_1 }}</td>
              <td>{{ item.EMAIL_PIC_1 }}</td>
              <td>{{ item.PIC_2 }}</td>
              <td>{{ item.EMAIL_PIC_2 }}</td>
              <td>
                {{ checkStatus(item.STATUS_PIC) }}
              </td>
            </tr>
            <tr v-show="selectedRowIndex === index" class="details-row" :key="'detail-row-' + index">
              <td :colspan="5 + tableData[0].details.length">
                <div class="details-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Tanggal PO</th>
                        <th>Nomor PO</th>
                        <th>Nama Vendor</th>
                        <th class="text-center">Nilai</th>
                        <th>Tingkat Kepuasan</th>
                        <th>Nilai PO</th>
                        <!-- <th>Dokumen</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detail, detailIndex) in item.details" :key="'detail-' + detailIndex">
                        <td>{{ detail.PO_DATE }}</td>
                        <td>{{ detail.PO_NUMBER }}</td>
                        <td>{{ detail.VENDOR_NAME }}</td>
                        <td class="text-center">{{ detail.CSI_SCORE }}</td>
                        <td>{{ satisfies(detail.CSI_SCORE) }}</td>
                        <td>{{ curencyDelimiter(detail.TOTAL_VALUE_IDR) }}</td>
                        <!-- <td>{{ detail.DOKUMENT }} <i class="fas fa-download" v-if="detail.DOKUMENT != ''"
                            @click="downloadDoc(detail.DOKUMENT)"></i></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <ModalEditSSI v-if="openEditData" :data="editDetailData" @close="closeModal" />
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
import * as XLSX from 'sheetjs-style'
export default {
  components: {
    // ModalEditSSI: () => import('../modal-edit-ssi.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      tableData: [
        {
          pcrGrup: 'Logistic BC (MTL)',
          pic: 'PIC 1',
          email: 'pic1@example.com',
          status: 'Konfirmasi 1',
          details: [
            {
              tanggalPO: '2023-07-01',
              nomorPO: 'PO001',
              namaVendor: 'Vendor 1',
              nilai: '1',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 900,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-02',
              nomorPO: 'PO002',
              namaVendor: 'Vendor 2',
              nilai: '2',
              kepuasan: 'Tidak Memuaskan',
              nilaiPO: 1800,
              dokumen: 'Dokumen SP',
            },
          ],
        },
        {
          pcrGrup: 'PCR Grup 2',
          pic: 'PIC 2',
          email: 'pic2@example.com',
          status: 'Konfirmasi 2',
          details: [
            {
              tanggalPO: '2023-07-03',
              nomorPO: 'PO003',
              namaVendor: 'Vendor 3',
              nilai: '3',
              kepuasan: 'Rendah',
              nilaiPO: 2700,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-04',
              nomorPO: 'PO004',
              namaVendor: 'Vendor 4',
              nilai: '4',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 3600,
              dokumen: 'Dokumen SP',
            },
          ],
        },
        {
          pcrGrup: 'Logistic BC (MTL)',
          pic: 'PIC 3',
          email: 'pic3@example.com',
          status: 'Konfirmasi 3',
          details: [
            {
              tanggalPO: '2023-07-01',
              nomorPO: 'PO013',
              namaVendor: 'Vendor 1',
              nilai: '1',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 900,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-02',
              nomorPO: 'PO023',
              namaVendor: 'Vendor 2',
              nilai: '2',
              kepuasan: 'Tidak Memuaskan',
              nilaiPO: 1800,
              dokumen: 'Dokumen SP',
            },
          ],
        },
        {
          pcrGrup: 'Logistic BC (MTL)',
          pic: 'PIC 4',
          email: 'pic4@example.com',
          status: 'Konfirmasi 4',
          details: [
            {
              tanggalPO: '2023-07-01',
              nomorPO: 'PO001',
              namaVendor: 'Vendor 1',
              nilai: '1',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 900,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-02',
              nomorPO: 'PO002',
              namaVendor: 'Vendor 2',
              nilai: '2',
              kepuasan: 'Tidak Memuaskan',
              nilaiPO: 1800,
              dokumen: 'Dokumen SP',
            },
          ],
        },
        {
          pcrGrup: 'Logistic BC (MTL)',
          pic: 'PIC 1',
          email: 'pic1@example.com',
          status: 'Konfirmasi 1',
          details: [
            {
              tanggalPO: '2023-07-01',
              nomorPO: 'PO001',
              namaVendor: 'Vendor 1',
              nilai: '1',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 900,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-02',
              nomorPO: 'PO002',
              namaVendor: 'Vendor 2',
              nilai: '2',
              kepuasan: 'Tidak Memuaskan',
              nilaiPO: 1800,
              dokumen: 'Dokumen SP',
            },
          ],
        },
        {
          pcrGrup: 'Logistic BC (MTL)',
          pic: 'PIC 1',
          email: 'pic1@example.com',
          status: 'Konfirmasi 1',
          details: [
            {
              tanggalPO: '2023-07-01',
              nomorPO: 'PO001',
              namaVendor: 'Vendor 1',
              nilai: '1',
              kepuasan: 'Sangat Buruk',
              nilaiPO: 900,
              dokumen: 'Dokumen SP',
            },
            {
              tanggalPO: '2023-07-02',
              nomorPO: 'PO002',
              namaVendor: 'Vendor 2',
              nilai: '2',
              kepuasan: 'Tidak Memuaskan',
              nilaiPO: 1800,
              dokumen: 'Dokumen SP',
            },
          ],
        },
      ],
      selectedRowIndex: null,
      searchPcrGrupPIC: '',
      searchNamaVendor: '',
      editDetailData: {
        pcrGrup: '',
        pic: '',
        email: '',
        status: '',
        details: [],
      },
      filteredData: [],
      openEditData: false,
      selectedMailRowIndex: null,
      clickedMailRows: [],
      // Tambahkan properti untuk menyimpan status klik
      // isMailClicked: false,
    };
  },
  computed: {
    confirmLevel2() {
      return this.$store.state.kpiStore.ssiCount.user_confirm_level_2;
    },
    confirmLevel3() {
      return this.$store.state.kpiStore.ssiCount.user_confirm_level_3;
    },
  },
  methods: {
    satisfies(val) {
      if (val == 0) {
        return 'Belum Di Nilai'
      } else if (val == 1) {
        return 'Sangat Buruk'
      } else if (val == 2) {
        return 'Tidak Puas'
      } else if (val == 3) {
        return 'Cukup Puas'
      } else if (val == 4) {
        return 'Puas'
      } else if (val == 5) {
        return 'Sangat Puas'
      } else {
        return 'Belum Di Nilai'
      }
    },

    checkMailSend(item) {
      if (item.STATUS_PIC == '0' || item.STATUS_PIC == null) {
        if (item.is_send_1 == 0) {
          return true
        }

        return false
      } else if (item.STATUS_PIC == '1') {
        if (item.is_send_2 == 0) {
          return true
        }

        return false
      } else if (item.STATUS_PIC == '2') {
        return false
      }
    },
    checkStatus(value) {
      switch (value) {
        case '0':
          return 'Belum Konfirmasi';
          break;
        case '1':
          return 'Konfirmasi PIC 1';
          break;
        case '2':
          return 'Konfirmasi PIC 2';
          break;

        default:
          return 'Belum Konfirmasi'
          break;
      }
    },
    closeModal() {
      this.openEditData = false;
    },
    toggleDetails(index) {
      if (this.selectedRowIndex === index) {
        this.selectedRowIndex = null; // Menutup tabel jika baris diklik kembali
      } else {
        this.selectedRowIndex = index; // Membuka tabel untuk baris yang diklik
      }
    },
    preventDetailToggle(index, event) {

      const clickedElement = event.target.tagName.toLowerCase();
      if (clickedElement !== 'svg' && clickedElement !== 'input') {
        this.toggleDetails(index);
      }
    },
    goBack() {
      this.$emit('changeContent', 'user_confirmation')
    },
    convertData(confirm2, confirm3) {
      return confirm2.map(item2 => {
        const GR_IDS = item2.GR_IDS.split(',').map(Number);
        const details = confirm3.filter(item3 => GR_IDS.includes(item3.GR_ID));
        return { ...item2, details };
      });
    },

    async applyFilter() {
      const convert = await this.convertData(this.confirmLevel2, this.confirmLevel3);

      this.filteredData = convert.filter(item => {
        const pcrGrupMatch = item.PCR_GROUP.toLowerCase().includes(this.searchPcrGrupPIC.toLowerCase());
        const picMatch = item.PIC_1.toLowerCase().includes(this.searchPcrGrupPIC.toLowerCase());
        const namaVendorMatch = item.details.some(detail => detail.VENDOR_NAME.toLowerCase().includes(this.searchNamaVendor.toLowerCase()));
        return (pcrGrupMatch || picMatch) && namaVendorMatch;
        return (pcrGrupMatch || picMatch)
      });
    },
    async mailAllPIC() {
      for (let i in this.confirmLevel2) {
        if (this.checkMailSend(this.confirmLevel2[i])) {
          let data = this.confirmLevel2[i]
          data.server = 'bc'
          await this.$store.dispatch('kpiStore/sendSingleMail', data)

          let list = this.confirmLevel2
          if (this.confirmLevel2[i].STATUS_PIC == '0' || this.confirmLevel2[i].STATUS_PIC == null) {
            list[i].is_send_1 = 1
          } else if (this.confirmLevel2[i].STATUS_PIC == '1') {
            list[i].is_send_2 = 1
          }

          this.$store.commit('kpiStore/UPDATE_DATA', {
            value: {
              ...this.$store.state.kpiStore.ssiCount,
              user_confirm_level_2: list
            },
            name: 'ssiCount'
          })
        } else {
          // do nothing
        }
      }
    },
    mailPcrGrup(index, value) {
      if (this.checkMailSend(value)) {
        let data = value
        data.server = 'bc'
        this.$store.dispatch('kpiStore/sendSingleMail', data)

        let list = this.confirmLevel2
        if (value.STATUS_PIC == '0' || value.STATUS_PIC == null) {
          list[index].is_send_1 = 1
        } else if (value.STATUS_PIC == '1') {
          list[index].is_send_2 = 1
        }

        this.$store.commit('kpiStore/UPDATE_DATA', {
          value: {
            ...this.$store.state.kpiStore.ssiCount,
            user_confirm_level_2: list
          },
          name: 'ssiCount'
        })
      } else {
        return false
      }


    },
    editData(data) {
      this.editDetailData = {
        tanggalPO: data.tanggalPO,
        nomorPO: data.nomorPO,
        namaVendor: data.namaVendor,
        nilai: data.nilai,
        kepuasan: data.kepuasan,
        nilaiPO: data.nilaiPO,
        dokumen: data.dokumen,
      }
      this.openEditData = true;
    },
    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    downloadReport() {
      const exportTitle = 'SSI - User Confirmation'
      let newData = this.confirmLevel2.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          PCR_GROUP: item.PCR_GROUP,
          PIC_1: item.PIC_1,
          EMAIL_PIC_1: item.EMAIL_PIC_1,
          PIC_2: item.PIC_2,
          EMAIL_PIC_2: item.EMAIL_PIC_2,
          STATUS_PIC: this.checkStatus(item.STATUS_PIC),
        }

        return newDataItem
      })

      // newData.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['NO', 'PCR GRUP', 'PIC 1', 'EMAIL PIC 1', 'PIC 2', 'EMAIL PIC 2', 'STATUS KONFIRMASI']
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  },
  mounted() {
    this.applyFilter();
  },
};
</script>
<style scoped>
.gray-stroke path {
  stroke: #a0a0a0;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 0 1rem;
  margin-bottom: 2rem;
}

.top-action-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0px 45px;
  gap: 20px;
  margin: 20px 0px;
}

.top-action-wrapper button {
  display: flex;
  justify-content: center;
  width: 200px;
  height: 30px;

  background-color: white;
  color: var(--gray-700, #344054);
  font-family: Segoe UI;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.top-action-wrapper input {
  display: flex;
  width: 200px;
  height: 30px;
  padding: 8px 4px;
  border: none;
  border-bottom: 2px solid black;
  font-size: 12px;
  border-radius: 5px;
  background: var(--base-white, #FFF);
  box-shadow: 0px 4px 4px 0px rgba(16, 24, 40, 0.05);
}

/* .details-row {
    background-color: #e0e8f4;
  } */

.details-table {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid black;
  border-radius: 1rem;
  /* background-color: #e0e8f4; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-wrapper {
  padding: 0px 30px;
  margin: 0 auto;
  max-height: 300px;
  overflow-y: scroll;
}

table {
  margin: 0 auto;
  width: 100%;
  color: var(--gray-900, #101828);
  text-align: left;

  border: none;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

tr,
td {
  border: none;
  width: auto;
  padding: 0px 0px;
  word-wrap: break-word;
}

table td input[type="checkbox"] {
  vertical-align: middle;
}


.input-wrapper {
  position: relative;
}


.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.search-icon i {
  font-size: 16px;
  /* Tambahkan properti lainnya sesuai kebutuhan Anda */
}
</style>